import { render, staticRenderFns } from "./SpeakersNotes.vue?vue&type=template&id=2663e51a&"
import script from "./SpeakersNotes.vue?vue&type=script&lang=js&"
export * from "./SpeakersNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports